export function colorGenerator(data){
  let dataNumbers = Object.values(data);
  return dataNumbers.map(item => {
    return paintBar(item)
  })
}

export function paintBar(value){
  return value >= 0 ? 'rgba(0, 105, 0, 1)' : 'rgba(167, 0, 0, 1)'
}

export function paintTotals(value){
  return value >= 0 ? 'rgba(0, 179, 0, 1)' : 'rgba(255, 0, 0, 1)'
}